module.exports = __webpack_public_path__ + "static/media/3_graph3.143369f2.svg";